<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><span href="#/whiterose_epi01#epi01" title="Link target outside of Sample">Epigraph</span></p>
</div>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/whiterose_ch01#ch01">Begin Reading</a></p>
</div>
<p class="spaceBreak"> </p>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/whiterose_ata01#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry" id="adc_01">
<p class="contentsEntryName"><span href="#/whiterose_adc01#adc01" title="Link target outside of Sample">Other Books by Amy Ephron</span></p>
</div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/whiterose_cop01#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/whiterose_atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// whiterose_con01.vue?4cde0141